import React, {useEffect} from 'react';
import JobsTable from "./components/JobsTable/JobsTable";
import JobsFilters from "./components/JobsFilters/JobsFilters";
import {fetchData} from "./services/apify";
import {Job} from "./components/Job/Job.types";

type Props = {
    keywordsPlaceholder: string
    workplacesPlaceholder: string
    noJobsText: string
}

type Data = {
    jobs: any[]
    url: string
    lang: string
}

const App: React.FC<Props> = ({keywordsPlaceholder, workplacesPlaceholder, noJobsText}) => {
    const [isReady, setIsReady] = React.useState(false)
    const [data, setData] = React.useState<Data>({jobs: [], url: '', lang: ''})
    const [workplaces, setWorkplaces] = React.useState<{ value: string, label: string }[]>([])
    const [textFilter, setTextFilter] = React.useState('')
    const [selectedWorkplaces, setSelectedWorkplaces] = React.useState<{ value: string, label: string }[]>([])

    useEffect(() => {
        fetchData()
            .then((data) => {
                data.forEach((langData: Data) => {
                    if (langData.lang === document.getElementsByTagName('html')[0].getAttribute('lang')) {
                        let jobsData: Data[] = []
                        let workplacesData: { value: string, label: string }[] = []
                        const workplacesSet = new Set()

                        langData.jobs.forEach((job) => {
                            jobsData.push({...job, visible: true})

                            if (job.city.indexOf(',') !== -1) {
                                job.city.split(',').forEach((city: string) => {
                                    const trimmedCity = city.trim()
                                    if (!workplacesSet.has(trimmedCity)) {
                                        workplacesSet.add(trimmedCity)
                                        workplacesData.push({value: trimmedCity, label: trimmedCity})
                                    }
                                })
                            } else {
                                const trimmedCity = job.city.trim()
                                if (!workplacesSet.has(trimmedCity)) {
                                    workplacesSet.add(trimmedCity)
                                    workplacesData.push({value: trimmedCity.toLowerCase(), label: trimmedCity})
                                }
                            }
                        })
                        langData.jobs = jobsData

                        workplacesData.sort((a, b) => {
                            return a.value.localeCompare(b.value)
                        })

                        setWorkplaces(workplacesData)
                        setData(langData)
                    }
                })
            })
            .catch((error) => {
                console.error('An error occurred while fetching data:', error)
            })
            .finally(() => {
                setIsReady(true)
            })
    }, [])

    const filterJobs = () => {
        let filteredJobs: Job[] = []

        data.jobs.forEach((job) => {
            const matchesTextFilter = textFilter
                ? job.title.toLowerCase().includes(textFilter.toLowerCase()) || job.city.toLowerCase().includes(textFilter.toLowerCase())
                : true

            const matchesWorkplaceFilter = selectedWorkplaces.length
                ? selectedWorkplaces.some((selectedOption) => job.city.toLowerCase().includes(selectedOption.value.toLowerCase()))
                : true

            job.visible = matchesTextFilter && matchesWorkplaceFilter
            filteredJobs.push(job)
        })

        setData({...data, jobs: filteredJobs})
    }

    const onTextFilterChange = (event: React.FormEvent<HTMLInputElement>) => {
        const text = (event.target as HTMLInputElement).value
        setTextFilter(text)
    }

    const onSelectFilterChange = (selectedOptions: any) => {
        setSelectedWorkplaces(selectedOptions || [])
    }

    useEffect(() => {
        filterJobs()
    }, [textFilter, selectedWorkplaces])

    return isReady ? (
        <div className="tc-website-jobsscraper">
            <JobsFilters
                onTextInputChange={onTextFilterChange}
                onSelectChange={onSelectFilterChange}
                workplaces={workplaces}
                keywordsPlaceholder={keywordsPlaceholder}
                workplacesPlaceholder={workplacesPlaceholder}/>
            <JobsTable jobs={data.jobs} noJobsText={noJobsText}/>
        </div>
    ) : (
        <div className={'tc-website-jobsscraper loading'}>
            <div id={'loader'}></div>
        </div>
    )
}

export default App
